export class Test {
	sayHello() {
		console.log("Hello world!");
		console.log("ES6 is connected successfully.");
	}
}
